<shared-badge
  [class]="'badge badge-pill badge-success'"
  [label]="label"
  [tooltip]="tooltip"
>
</shared-badge>
